function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { message, Descriptions, Tabs, Skeleton, List, Button, Modal, DatePicker, notification, Space, Form } from "antd";
import NewAppointment from "./forms/NewAppointment";
import Calendar from 'react-calendar';
import Common from "./includes/Common";
import { PhoneFill, PersonFill, PencilSquare, CalendarEventFill, TrashFill, PersonLock, ListCheck, ArrowClockwise } from 'react-bootstrap-icons';
import Moment from "react-moment";
import moment from "moment";
import dayjs from "dayjs";
import EditCustomer from "./forms/EditCustomer";
import EditAppointment from "./forms/EditAppointment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;

var Appointment = function Appointment() {
  var _Modal$useModal = Modal.useModal(),
      _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
      confirm = _Modal$useModal2[0].confirm,
      contextHolder = _Modal$useModal2[1];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      appointments = _useState2[0],
      setAppiontments = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isDataLoading = _useState4[0],
      setIsDataLoading = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      dataChanged = _useState6[0],
      setDataChanged = _useState6[1];

  var _useState7 = useState(""),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedId = _useState8[0],
      setSelectedId = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isUpcomingLoading = _useState10[0],
      setIsUpcomingLoading = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      showEditAppointment = _useState12[0],
      setShowEditAppointment = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      currentCustomer = _useState14[0],
      setCurrenCustomer = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      monthlyAppointments = _useState16[0],
      setMonthlyAppointments = _useState16[1];

  var _useState17 = useState([]),
      _useState18 = _slicedToArray(_useState17, 2),
      upcommingAppointments = _useState18[0],
      setUpcommingAppointments = _useState18[1];

  var _useState19 = useState([]),
      _useState20 = _slicedToArray(_useState19, 2),
      monthlyAppointmentsDate = _useState20[0],
      setMonthlyAppointmentsDate = _useState20[1];

  var _useState21 = useState([]),
      _useState22 = _slicedToArray(_useState21, 2),
      upcomingAppointmentsDate = _useState22[0],
      setUpcomingAppointmentsDate = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      showAdd = _useState24[0],
      setShowAdd = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      isPatientsLoading = _useState26[0],
      setIsPatientsLoading = _useState26[1];

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      showEdit = _useState28[0],
      setShowEdit = _useState28[1];

  var _useState29 = useState(null),
      _useState30 = _slicedToArray(_useState29, 2),
      selectedAp = _useState30[0],
      setSelectedAp = _useState30[1];

  var _useState31 = useState([]),
      _useState32 = _slicedToArray(_useState31, 2),
      createdCustomers = _useState32[0],
      setCreatedCustomers = _useState32[1];

  var _useState33 = useState(dayjs().startOf("week")),
      _useState34 = _slicedToArray(_useState33, 2),
      from = _useState34[0],
      setFrom = _useState34[1];

  var _useState35 = useState(dayjs().endOf("week")),
      _useState36 = _slicedToArray(_useState35, 2),
      to = _useState36[0],
      setTo = _useState36[1];

  var _useState37 = useState(dayjs().startOf("month")),
      _useState38 = _slicedToArray(_useState37, 2),
      apFrom = _useState38[0],
      setApFrom = _useState38[1];

  var _useState39 = useState(dayjs().endOf("month")),
      _useState40 = _slicedToArray(_useState39, 2),
      apTo = _useState40[0],
      setApTo = _useState40[1];

  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getappointments/" + apFrom.format() + "/" + apTo.format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUpcomingAppointmentsDate([]);
        setAppiontments([]);
        setAppiontments(response.data.appointments);
        response.data.appointments.forEach(function (e) {
          setUpcomingAppointmentsDate(function (prev) {
            return [].concat(_toConsumableArray(prev), [moment(e.date).format("DD-MM-YYYY")]);
          });
        });
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged, apFrom, apTo]);
  useEffect(function () {
    setIsPatientsLoading(true);
    axios.get(Common.baseApiUrl + "getusercreatedpatients/" + from.format() + "/" + to.format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCreatedCustomers(response.data.customers);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsPatientsLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "white-bg",
      style: {
        minHeight: "650px"
      },
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 8,
            children: /*#__PURE__*/_jsx(Tabs, {
              animated: true,
              items: [{
                key: 1,
                label: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(ListCheck, {}), " Liste"]
                }),
                children: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Form, {
                    onFinish: function onFinish(values) {
                      setApFrom(moment(values.period[0].$d).format());
                      setApTo(moment(values.period[1].$d).format());
                    },
                    layout: "vertical",
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      children: [/*#__PURE__*/_jsx(Form.Item, {
                        name: "period",
                        rules: [{
                          required: true,
                          message: "Choisir une date de depart"
                        }],
                        children: /*#__PURE__*/_jsx(RangePicker, {
                          needConfirm: false,
                          format: "DD/MM/YYYY"
                        })
                      }), /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(Form.Item, {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            htmlType: "submit",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "Filtrer"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Form.Item, {
                          children: /*#__PURE__*/_jsx(Button, {
                            loading: isUpcomingLoading,
                            type: "link",
                            onClick: function onClick() {
                              setApFrom(dayjs().startOf("month"));
                              setApTo(dayjs().endOf("month"));
                            },
                            icon: /*#__PURE__*/_jsx(ArrowClockwise, {
                              size: 24
                            }),
                            children: "Rdv \xE0 venir"
                          })
                        })]
                      })]
                    })
                  }), /*#__PURE__*/_jsx("br", {}), appointments.map(function (a) {
                    return /*#__PURE__*/_jsxs(Descriptions, {
                      style: {
                        marginBottom: '10px'
                      },
                      size: "small",
                      bordered: true,
                      column: 1,
                      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Rdv Patient"
                        }),
                        children: /*#__PURE__*/_jsxs(Space, {
                          direction: "horizontal",
                          children: [/*#__PURE__*/_jsxs("div", {
                            children: [a.customer.firstname + " " + a.customer.lastname + " (" + a.customer.idnumber + ") ", /*#__PURE__*/_jsxs("span", {
                              style: {
                                color: "#996444",
                                fontWeight: "bold"
                              },
                              children: ["- Le ", /*#__PURE__*/_jsx(Moment, {
                                locale: "Fr",
                                format: "DD/MM/YYYY hh:mm",
                                children: a.date
                              })]
                            })]
                          }), /*#__PURE__*/_jsx(Button, {
                            type: "default",
                            onClick: function onClick() {
                              setSelectedAp(a);
                              setShowEditAppointment(true);
                            },
                            children: /*#__PURE__*/_jsx(PencilSquare, {
                              size: 17
                            })
                          }), contextHolder, /*#__PURE__*/_jsx(Button, {
                            type: "default",
                            onClick: function onClick() {
                              confirm({
                                title: /*#__PURE__*/_jsx("b", {
                                  children: "Confirmez - vous ? "
                                }),
                                content: /*#__PURE__*/_jsxs("p", {
                                  children: ["La suppression du rendez-vous pour le patient ", a.customer.firstname + " " + a.customer.lastname, " ?"]
                                }),
                                onOk: function onOk() {
                                  axios.get(Common.baseApiUrl + "deleteappointment/" + a.id + "/" + Common.currentUser.id).then(function (response) {
                                    if (response.data.status == 200) {
                                      notification.success(_defineProperty({
                                        message: "Ok!"
                                      }, "message", response.data.message));
                                      setDataChanged(true);
                                    } else {
                                      notification.error(_defineProperty({
                                        message: "Oops!"
                                      }, "message", response.data.message));
                                    }
                                  })["catch"](function (error) {
                                    notification.error(_defineProperty({
                                      message: "Oops!"
                                    }, "message", "Une erreur est survenue"));
                                  })["finally"](function () {});
                                }
                              });
                            },
                            children: /*#__PURE__*/_jsx(TrashFill, {
                              size: 17
                            })
                          })]
                        })
                      }), /*#__PURE__*/_jsx(Descriptions.Item, {
                        label: "Raison",
                        children: a.reason
                      }), /*#__PURE__*/_jsx(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx(PhoneFill, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx("b", {
                          children: a.customer.mobile.toString().slice(3)
                        })
                      })]
                    }, a.id);
                  }), isDataLoading && appointments.length == 0 && /*#__PURE__*/_jsx("div", {
                    children: "Vous n'avez aucun rendez-vous"
                  })]
                })
              }, {
                key: 2,
                label: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(CalendarEventFill, {}), " Calendrier"]
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsx(Calendar, {
                    style: {
                      height: 900,
                      width: "100%"
                    },
                    onChange: null,
                    locale: "fr-FR",
                    value: null,
                    tileClassName: function tileClassName(_ref) {
                      var date = _ref.date,
                          view = _ref.view;

                      if (monthlyAppointmentsDate.find(function (x) {
                        return x === moment(date).format("DD-MM-YYYY");
                      }) || upcomingAppointmentsDate.find(function (x) {
                        return x === moment(date).format("DD-MM-YYYY");
                      })) {
                        return 'highlight';
                      } else {
                        return 'reg_calendar_item';
                      }
                    },
                    tileDisabled: function tileDisabled(_ref2) {
                      var date = _ref2.date;
                      return date.getDay() === 0;
                    }
                  })
                })
              }, {
                key: 3,
                label: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PersonLock, {}), " Mes dossiers cr\xE9\xE9s"]
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: createdCustomers.length > 0 && /*#__PURE__*/_jsx(List, {
                    className: "demo-loadmore-list",
                    loading: isPatientsLoading,
                    itemLayout: "horizontal",
                    dataSource: createdCustomers,
                    renderItem: function renderItem(item) {
                      return /*#__PURE__*/_jsx(List.Item, {
                        actions: [/*#__PURE__*/_jsx(Button, {
                          icon: /*#__PURE__*/_jsx(PencilSquare, {}),
                          type: "link",
                          onClick: function onClick() {
                            setCurrenCustomer(item);
                            setShowEdit(true);
                          },
                          children: "Modifier"
                        }, "list-loadmore-edit"), /*#__PURE__*/_jsx(Button, {
                          icon: /*#__PURE__*/_jsx(CalendarEventFill, {}),
                          type: "link",
                          onClick: function onClick() {
                            setSelectedId(item.idnumber);
                          },
                          children: "Rendez-vous"
                        }, "list-loadmore-more")],
                        children: /*#__PURE__*/_jsxs(Skeleton, {
                          avatar: true,
                          title: false,
                          loading: isPatientsLoading,
                          active: true,
                          children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                            avatar: /*#__PURE__*/_jsx(PersonFill, {}),
                            title: /*#__PURE__*/_jsx("b", {
                              children: item.firstname + " " + item.lastname
                            }),
                            description: "Code Patient: " + item.idnumber
                          }), /*#__PURE__*/_jsx("div", {})]
                        })
                      });
                    }
                  })
                })
              }]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 4,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                borderRadius: "8px",
                background: "#FED087",
                padding: "15px"
              },
              children: /*#__PURE__*/_jsx(NewAppointment, {
                customerId: selectedId,
                handler: function handler() {
                  setDataChanged(true);
                }
              })
            })
          })]
        })
      })
    }), currentCustomer && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Modifier le dossier"
        }),
        width: {
          xs: '95%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '50%'
        },
        open: showEdit,
        onCancel: function onCancel() {
          setShowEdit(false);
        },
        footer: null,
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EditCustomer, {
          customer: currentCustomer,
          handleUpdate: function handleUpdate() {
            setShowEdit(false);
            notification.success({
              message: "Ok!",
              description: "Le dossier a été modifié"
            });
          }
        })
      })
    }), selectedAp && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Modifier un rendez-vous"
        }),
        width: {
          xs: '95%',
          sm: '80%',
          md: '40%',
          lg: '40%',
          xl: '30%',
          xxl: '30%'
        },
        open: showEditAppointment,
        onCancel: function onCancel() {
          setShowEditAppointment(false);
        },
        footer: null,
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EditAppointment, {
          appointment: selectedAp,
          handler: function handler() {
            setShowEditAppointment(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Le rdv a été modifié"
            });
          }
        })
      })
    })]
  });
};

export default Appointment;